import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { SECTORS } from "../lib/sectors";

const SITE = "https://riznwash.com";

export default function AreasIndex() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "RIZ N WASH", item: SITE },
        { "@type": "ListItem", position: 2, name: "Service areas", item: `${SITE}/areas` },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "RIZ N WASH service areas in Gurugram",
      itemListElement: SECTORS.map((s, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `${SITE}/laundry/${s.slug}`,
        name: `Laundry in ${s.name}, Gurugram`,
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-rw-bg text-rw-ink" data-testid="areas-index">
      <Seo
        title="Service Areas · Laundry Pickup in Gurugram"
        description="Every Gurugram sector RIZ N WASH covers — from DLF Phases to Sohna Road. Free doorstep laundry pickup and dry-cleaning delivery, 48-hour turnaround."
        path="/areas"
        jsonLd={jsonLd}
      />
      <Nav />

      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-12 md:pt-24 pb-8">
        <div className="overline mb-3">Coverage</div>
        <h1 className="font-display font-light text-4xl md:text-6xl tracking-tight leading-[1.05]">
          Every part of Gurugram, <em className="italic text-rw-blue not-italic">covered</em>.
        </h1>
        <p className="mt-6 text-rw-ink2 text-lg max-w-2xl leading-relaxed">
          Tap your area for pricing, slots, and one-tap booking. Don't see your sector? WhatsApp us —
          we're expanding every week.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-6 md:px-10 pb-24">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SECTORS.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/laundry/${s.slug}`}
                data-testid={`area-card-${s.slug}`}
                className="group block rounded-2xl border border-rw-ink/10 bg-rw-bg2 p-6 hover:border-rw-blue hover:shadow-lg transition-all"
              >
                <div className="overline text-rw-ink3">Gurugram</div>
                <div className="font-display text-2xl md:text-3xl mt-1 group-hover:text-rw-blue transition-colors">
                  {s.name}
                </div>
                {s.nearby?.length > 0 && (
                  <div className="mt-3 text-sm text-rw-ink2">
                    Near {s.nearby.slice(0, 2).join(", ")}
                  </div>
                )}
                <div className="mt-6 text-sm font-semibold text-rw-ink flex items-center gap-2">
                  Laundry in {s.name} <span aria-hidden>→</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <Footer />
    </div>
  );
}
